import React from 'react'
import { FormLabel, FormControl, FormGroup, FormText } from 'react-bootstrap'

const SelectFieldFormGroup = ({
  controlId,
  validationState,
  controlLabel,
  name,
  value,
  handleFieldChange,
  data,
  propName,
  labelName,
  help,
  ...rest
}) => {
  return (
    <FormGroup controlId={controlId}>
      <FormLabel>{controlLabel}</FormLabel>
      <FormControl
        name={name}
        value={value}
        as='select'
        placeholder='select'
        onChange={handleFieldChange}
        isInvalid={validationState}
        {...rest}
      >
        <option key={'select'} value={''} defaultValue={''} disabled>
          Select
        </option>
        {data.map((item, i) => (
          <option key={i} value={item[propName]}>
            {labelName ? item[labelName] : item[propName]}
          </option>
        ))}
      </FormControl>
      <FormControl.Feedback />
      <FormText className='small'>
        <em>{help}</em>
      </FormText>
    </FormGroup>
  )
}

export default SelectFieldFormGroup
